<template>
  <div class="hall-box">
    <div class="hall-list" v-for="(value,key) in hallList" :key="key">
      <div class="hall-list-left">
        <el-image :src="value.image" fit="cover"></el-image>
      </div>
      <div class="hall-list-right">
        <div class="hall-list-right-name">{{ value.name }}</div>
        <div class="hall-list-right-intro">{{ value.remark }}</div>
        <div class="hall-list-right-tags">
          <el-tag size="mini" type="error" v-if="value.outside === 1" class="tag">户外</el-tag>
          <el-tag size="mini" type="error" v-if="value.outside === 0" class="tag">室内</el-tag>
          <el-tag size="mini" type="success" class="tag">{{ value.buddhas_name }}</el-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getHalls} from '@/api/temple.js'
export default {
  props: {
    temple: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {
      hallList: [],
      form: {
        page: 1,
        count: 10,
        temple_id: 0,
        keyword: ''
      }
    }
  },
  mounted() {
    this.form.temple_id = this.temple
    this.init();
  },
  methods: {
    init() {
      getHalls(this.form).then(res=>{
        if(res.code === 200){
          this.hallList = res.data.data
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.hall-box{
  width: 100%;
  .hall-list{
    width: 100%;
    box-sizing: border-box;
    display:inline-flex;
    justify-content: space-between;
    border-radius: 10px;
    border: 1px solid #e5e9f0;
    margin-bottom: 10px;
    &-left{
      width:300px;
      height:180px;
      flex-shrink: 0;
      .el-image{
        width: 100%;
        height: 100%;
      }
    }
    &-right{
      width: 100%;
      height:180px;
      flex-shrink: 1;
      box-sizing: border-box;
      padding: 20px;
      display:inline-flex;
      flex-direction: column;
      justify-content: space-between;
      &-name{
        width: 100%;
        height: 20px;
        flex-shrink: 0;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      &-intro{
        width: 100%;
        height:180px;
        flex-shrink: 1;
        margin-bottom: 20px;
        font-size: 14px;
        color: #0e0e0e;;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 这里的数字表示显示的行数 */
  overflow: hidden;
      }
      &-tags{
        width: 100%;
        flex-shrink: 0;
        .tag{
          margin-right: 10px;
        }
      }
    }
  }
}
</style>